<template>
  <div class="info-table spacey-12" :style="companiesGrid">
    <div class="table-header d-contents">
      <div>{{ $t('Company') }}</div>
      <div>{{ $t('Representative') }}</div>
      <div class="flex-end">
        <span>{{ $t('Offer status') }}</span>
      </div>
      <div v-if="anyResends" />
    </div>
    <div
      v-for="(company, idx) in companies"
      :key="idx"
      class="table-row table-row_size-l d-contents"
    >
      <div class="cell text-primary text-mm">
        {{ companyName(company) }}
      </div>
      <div class="cell">
        <UserInfo v-if="showUserInfo(company)" :user="userInfo(company)" />
      </div>
      <div class="cell">
        <OfferStatus :status="company.status" :is-old="company.is_all_versions_old" />
      </div>
      <v-menu v-if="company.can_resend" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="tender-contractors__cell" v-bind="attrs" v-on="on">
            <Icon type="more-horizontal" size="20" />
          </div>
        </template>
        <DropdownMenu>
          <DropdownMenuElement left-icon="mail" @click.native="$emit('resend', company.id)">
            {{ $t('Resend invite') }}
          </DropdownMenuElement>
        </DropdownMenu>
      </v-menu>
      <div v-else-if="anyResends" class="cell"></div>
    </div>
  </div>
</template>

<script>
  import UserInfo from '@/components/ui/UserInfo';
  import OfferStatus from '@/components/tenders/OfferStatus';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import DropdownMenu from '@/components/ui/dropdown-menu/DropdownMenu';
  import { VMenu } from 'vuetify/lib';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'CompaniesTable',
    components: {
      OfferStatus,
      UserInfo,
      VMenu,
      DropdownMenuElement,
      DropdownMenu,
      Icon,
    },
    props: {
      companies: {
        type: Array,
        required: true,
      },
    },
    computed: {
      companiesGrid() {
        return {
          'grid-template-columns': this.anyResends ? '2fr 2.5fr 1fr 44px' : '2fr 2.5fr 1fr',
        };
      },
      anyResends() {
        return !!this.companies.find((company) => company.can_resend);
      },
    },
    methods: {
      userInfo(company) {
        return company?.contractor_contact_person_user;
      },
      companyName(company) {
        return company.contractor_team?.name;
      },
      showUserInfo(company) {
        return company?.contractor_responsible_users?.length;
      },
    },
  };
</script>
